import { QueryClient } from '@tanstack/react-query';

// Internal admin tool: data doesn't change second-to-second, and there's no
// need for aggressive retry/refetch churn on a handful of staff users.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
